import React, { useEffect, useState } from 'react'
import Header from '../../../Components/Header'
import Footer from '../../../Components/Footer'
import { Link } from 'react-router-dom'
import { ApiService } from '../../../Components/Services/apiServices'
import Skeleton from 'react-loading-skeleton'

const AboutUs = () => {

    const [homeaboutus, setHomeaboutus] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchhomeaboutus = async () => {
            try {
                const homeaboutusData = await ApiService.Commanfetchrequest("home-aboutus");
                setHomeaboutus(homeaboutusData);
                // console.log('Fetched About us:', homeaboutusData);
            } catch (error) {
                console.error('Error fetching home feature:', error);

            } finally {
                setLoading(false);
            }
        }

        fetchhomeaboutus();

    }, []);


    return (
        <>
            <Header />

            {loading ? (
                <>
                    <div className="container-fluid page-header mb-5 p-0">
                        <div className="container-fluid page-header-inner py-5">

                            <div className="container-fluid text-center pb-5">
                                <h1 className="display-3 text-white mb-3 animated slideInDown">
                                    <Skeleton width={200} height={50} />
                                </h1>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb justify-content-center text-uppercase">
                                        <li className="breadcrumb-item">
                                            <Skeleton width={50} height={20} />
                                        </li>
                                        <li className="breadcrumb-item text-white active" aria-current="page">
                                            <Skeleton width={50} height={20} />

                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>


                    <div className="container-xxl py-5">
                        <div className="container">
                            <div className="row g-5 align-items-center">
                                <div className="col-lg-6">
                                    <h6 className="section-title text-start text-primary text-uppercase"><Skeleton width={60} height={20} /></h6>
                                    <h1 className="mb-4"><Skeleton width={"100%"} height={50} /></h1>
                                    <p className="mb-4"><Skeleton width={"100%"} height={100} /></p>
                                    <div className="row g-3 pb-4">
                                        <div className="col-sm-4 wow fadeIn" data-wow-delay="0.1s">
                                            <div className="border rounded p-1">
                                                <Skeleton width={60} height={150} />
                                            </div>
                                        </div>
                                        <div className="col-sm-4 wow fadeIn" data-wow-delay="0.3s">
                                            <div className="border rounded p-1">
                                                <Skeleton width={60} height={150} />
                                            </div>
                                        </div>
                                        <div className="col-sm-4 wow fadeIn" data-wow-delay="0.5s">
                                            <Skeleton width={60} height={150} />
                                        </div>
                                    </div>
                                    <Link to="/about-us" className="btn py-3 px-5 mt-2"><Skeleton width={190} height={50} /></Link>
                                </div>
                                <div className="col-lg-6">
                                    <div className="row g-3">
                                        <div className="col-6 text-end">
                                            <Skeleton width={"100%"} height={150} />
                                        </div>
                                        <div className="col-6 text-start">
                                            <Skeleton width={"100%"} height={200} />
                                        </div>
                                        <div className="col-6 text-end">
                                            <Skeleton width={"100%"} height={110} />
                                        </div>
                                        <div className="col-6 text-start">
                                            <Skeleton width={"100%"} height={160} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                homeaboutus && (
                    <>
                        <div className="container-fluid page-header mb-5 p-0" style={{ backgroundImage: 'url(img/carousel-1.jpg)' }}>
                            <div className="container-fluid page-header-inner py-5">
                                <div className="container text-center pb-5">
                                    <h1 className="display-3 text-white mb-3 animated slideInDown">About Us</h1>
                                    <nav aria-label="breadcrumb">
                                        <ol className="breadcrumb justify-content-center text-uppercase">
                                            <li className="breadcrumb-item"><Link style={{ textDecoration: "none", color: "yellow" }} to="/">Home</Link></li><span style={{ color: "#fff" }}>/</span>
                                            <li className="breadcrumb-item"><a style={{ textDecoration: "none", color: "yellow" }} href="#">Pages</a></li><span style={{ color: "#fff" }}>/</span>
                                            <li className="breadcrumb-item text-white active" aria-current="page">About Us</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div className="container-xxl py-5">
                            <div className="container">
                                <div className="row g-5 align-items-center">
                                    <div className="col-lg-6">
                                        <h6 className="section-title text-start text-primary text-uppercase">About Us</h6>
                                        <h1 className="mb-4">{homeaboutus.heading} <span className="text-primary text-uppercase">WeJai</span></h1>
                                        <p className="mb-4" dangerouslySetInnerHTML={{ __html: homeaboutus?.description }}></p>
                                        <div className="row g-3 pb-4">
                                            <div className="col-sm-4 wow fadeIn" data-wow-delay="0.1s">
                                                <div className="border rounded p-1">
                                                    <div className="border rounded text-center p-4">
                                                        <i className="fa fa-hotel fa-2x text-primary mb-2" />
                                                        <h2 className="mb-1" data-toggle="counter-up">{homeaboutus.title_first}</h2>
                                                        <p className="mb-0">Rooms</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 wow fadeIn" data-wow-delay="0.3s">
                                                <div className="border rounded p-1">
                                                    <div className="border rounded text-center p-4">
                                                        <i className="fa fa-users-cog fa-2x text-primary mb-2" />
                                                        <h2 className="mb-1" data-toggle="counter-up">{homeaboutus.title_second}</h2>
                                                        <p className="mb-0">Staffs</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 wow fadeIn" data-wow-delay="0.5s">
                                                <div className="border rounded p-1">
                                                    <div className="border rounded text-center p-4">
                                                        <i className="fa fa-users fa-2x text-primary mb-2" />
                                                        <h2 className="mb-1" data-toggle="counter-up">{homeaboutus.title_third}</h2>
                                                        <p className="mb-0">Total Bookings</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Link to="/about-us" className="btn btn-primary py-3 px-5 mt-2">Explore More</Link>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="row g-3">
                                            <div className="col-6 text-end">
                                                <img className="img-fluid rounded w-75 wow zoomIn" data-wow-delay="0.1s" src="img/about-1.jpg" style={{ marginTop: '25%' }} />
                                            </div>
                                            <div className="col-6 text-start">
                                                <img className="img-fluid rounded w-100 wow zoomIn" data-wow-delay="0.3s" src="img/about-2.jpg" />
                                            </div>
                                            <div className="col-6 text-end">
                                                <img className="img-fluid rounded w-50 wow zoomIn" data-wow-delay="0.5s" src="img/about-3.jpg" />
                                            </div>
                                            <div className="col-6 text-start">
                                                <img className="img-fluid rounded w-75 wow zoomIn" data-wow-delay="0.7s" src="img/about-4.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )

            )}
            <Footer />
        </>
    )
}

export default AboutUs
